__turbopack_context__.v({
  "crypto": "Asset-module-scss-module__Cvz2-a__crypto",
  "fiat": "Asset-module-scss-module__Cvz2-a__fiat",
  "listItem": "Asset-module-scss-module__Cvz2-a__listItem",
  "listItemError": "Asset-module-scss-module__Cvz2-a__listItemError",
  "listItemSelected": "Asset-module-scss-module__Cvz2-a__listItemSelected",
  "pos": "Asset-module-scss-module__Cvz2-a__pos",
});
